// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CreditExposureType {
  BankGuarantee = "BANK_GUARANTEE",
  CashCollateral = "CASH_COLLATERAL",
}
export default CreditExposureType;
